import { IconButton, Tooltip } from '@material-ui/core';
import React, { Fragment, useContext, useState } from 'react';
import { FindInPage } from '@material-ui/icons';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../utils/GridUtils';
import MaterialTable from 'material-table';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import FileDownloaderAcerBrag from '../../components/UI/FileDownloaderAcerBrag';
import { PaymentOrdersAPI } from '../../services/PaymentOrdersAPI';
import { AppContext } from '../../contexts/AppContext';
import { decodeFile } from '../../utils/MiscellaneousUtils';
import { LoginContext } from '../../contexts/LoginContext';

const PaymentOrdersGrid = ({ data, tableRef }) => {
  const [open, setOpen] = useState(false);
  const { showError } = useContext(AppContext);
  const { isAllowedByRole } = useContext(LoginContext);

  const handleDownloadFile = (url, fileName) => {
    return PaymentOrdersAPI.getFile(url)
      .then(res => decodeFile(res, fileName))
      .catch(error => showError('las órdenes de pago / retenciones se pueden descargar luego de 24 hs. de la acreditación'));
  };

  const colDefs = useGridColDefs([
    { title: 'Orden de pago', field: 'payOrderCode' },
    { title: 'Pago disponible desde', field: 'paymentAvaibleDate', valueType: 'date' },
    { title: 'Moneda', field: 'currency', align: 'center', hidden: true },
    { title: 'Importe', field: 'localCurrencyImport', currencyRef: 'currency' },
    {
      title: 'Ver OP',
      field: 'urlPdfPayOrder',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <Tooltip
          title={value !== '' ? 'Ver adjuntos' : 'No se encontraron adjuntos'}
          enterDelay={tooltipDelay}
          enterNextDelay={tooltipDelay}>
          <span>
            <IconButton
              disabled={value === ''}
              aria-label="downloadPaymentOrder"
              size="small"
              color="primary"
              onClick={() => isAllowedByRole() && handleDownloadFile(value, 'OrdenPago.pdf')}>
              <FindInPage />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Ver Retenciones',
      field: 'urlPdfWithholding',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <Tooltip
          title={value !== '' ? 'Ver adjuntos' : 'No se encontraron adjuntos'}
          enterDelay={tooltipDelay}
          enterNextDelay={tooltipDelay}>
          <span>
            <IconButton
              disabled={value === ''}
              aria-label="downloadWithholding"
              size="small"
              color="primary"
              onClick={() => isAllowedByRole() && handleDownloadFile(value, 'Retencion.pdf')}>
              <FindInPage />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
  ]);

  return (
    <Fragment>
      <DialogAcerBrag open={open} setOpen={setOpen} title="Documentos">
        <FileDownloaderAcerBrag data={[1, 2, 3]} action={e => setOpen(false)} />
      </DialogAcerBrag>
      <MaterialTable
        {...defaultGridOptions}
        columns={colDefs}
        data={data}
        tableRef={tableRef}
        options={{
          ...defaultGridOptions.options,
          pageSize: tableRef?.current?.dataManager?.pageSize || defaultGridOptions.options.pageSize,
        }}
      />
    </Fragment>
  );
};

export default PaymentOrdersGrid;
